<template>
  <div class="common-layout">
    <!-- 春节主题Loading -->
    <SpringFestivalLoading :new-year-config="newYearConfig" />
    <!-- 春节氛围装饰 -->
    <SpringFestivalDecorations :new-year-config="newYearConfig" />
    <template v-if="!isLoginPage">
      <el-container style="height: 100vh; display: flex; flex-direction: column;">
        <el-header height="60px" style="flex-shrink: 0;">
          <div class="header-container">
            <AnnouncementBar />
          </div>
        </el-header>
        <el-container style="flex: 1; height: calc(100vh - 90px);">
          <!-- 左侧菜单 暂时移除 -->
          <!-- <el-aside width="160px" style="height: 100%;">
            <MenuNavigation />
          </el-aside> -->
          <el-container style="height: 100%; overflow: hidden;">
            <el-main class="main-container">
              <router-view />
            </el-main>
            <el-footer height="auto">
              <div class="footer-container">
                <FooterBar />
              </div>
            </el-footer>
          </el-container>
        </el-container>
      </el-container>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import MenuNavigation from '@/components/navigation/MenuNavigation.vue'
import AnnouncementBar from '@/components/navigation/AnnouncementBar.vue'
import FooterBar from '@/components/navigation/FooterBar.vue'
import SpringFestivalLoading from '@/components/SpringFestivalLoading.vue'
import SpringFestivalDecorations from '@/components/SpringFestivalDecorations.vue'

const route = useRoute()
const store = useStore()
const newYearConfig = ref(null)

const isLoginPage = computed(() => route.meta.isLoginPage)

// 初始化时请求春节配置
onMounted(async () => {
  const config = await store.dispatch('fetchNewYearConfig')
  newYearConfig.value = config
})
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 150px;
  min-height: 400px;
}
.header-container {
  height: 60px;
  background-color: rgb(250, 250, 250);
}
.footer-container {
  height: 30px;
  background-color: rgb(250, 250, 250);
}
</style>
<style>
.main-container {
  height: 100%;
  width: 100%;
  overflow: auto;
}
/* 通用清除浏览器默认样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
